import { ClientStatusCode } from "@upmind-automation/types";
import i18n from "@/i18n";
import type { TranslateResult } from "vue-i18n";

export interface IClientStatusMapEntry {
  code: ClientStatusCode;
  label: string | TranslateResult;
  description: string | TranslateResult;
  color?: string;
  colorContrast?: string;
}

const ClientStatusMap = (): Record<
  ClientStatusCode,
  IClientStatusMapEntry
> => ({
  [ClientStatusCode.NEW]: {
    code: ClientStatusCode.NEW,
    label: i18n.t("_.new"),
    description: i18n.t("_sentence.client_new_desc"),
    color: "#018ffd",
    colorContrast: "#ffffff"
  },
  [ClientStatusCode.ACTIVE]: {
    code: ClientStatusCode.ACTIVE,
    label: i18n.t("_.active"),
    description: i18n.t("_sentence.client_active_desc"),
    color: "#10b981",
    colorContrast: "#ffffff"
  },
  [ClientStatusCode.INACTIVE]: {
    code: ClientStatusCode.INACTIVE,
    label: i18n.t("_.inactive"),
    description: i18n.t("_sentence.client_inactive_desc")
  }
});

export { ClientStatusMap };
